import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("circle", { key: '0', fill: '#000000', cx: '12', cy: '12', r: '12' }),
    React.createElement("circle", { key: '1', fill: '#FFFFFF', cx: '12', cy: '12', r: '10' }),
    React.createElement("path", { key: '2', fill: '#000000', d: 'M19.4,8.5c0-1.1-0.9-2.1-2.1-2.1H5.6c-0.5,0-1,0.5-1,1v6.3c0,1.1,0.9,2.1,2.1,2.1h0.2c0,1.8,1.3,3.1,3.1,3.1\n\ts3.1-1.3,3.1-3.1h0.2c0,1.8,1.3,3.1,3.1,3.1s3.1-1.3,3.1-3.1L19.4,8.5z' }),
    React.createElement("circle", { key: '3', fill: '#FFFFFF', cx: '9.9', cy: '15.6', r: '1.4' }),
    React.createElement("circle", { key: '4', fill: '#FFFFFF', cx: '16.5', cy: '15.6', r: '1.4' }),
], 'TransportConditionTrailer');
const TransportConditionTrailerIcon = function (props) {
    return React.createElement(SvgIcon, Object.assign({}, props));
};
export default memo(TransportConditionTrailerIcon);
